import type { JSX } from 'react'

export const Ghost502Icon = (): JSX.Element => (
  <use href='#ghost502' height='100%' width='100%' />
)
